import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  MenuItem,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import {
  SelectValidator,
  TextValidator,
  ValidatorForm,
} from 'react-material-ui-form-validator';
import { useDispatch, useSelector } from 'react-redux';
import {
  setActiveBreadcrumbHce,
  traerPisoConsultorio,
  traerRelacionEfectorCMEspecialidad,
} from '../../../actions/hce/hceActions';
import { MENU_HCE } from '../../../utils/constants';
import { ListadoPacientes } from './ListadoPacientes';

const fecha = new Date();

export const IngresoHce = (props) => {
  const { relEfectorCMEspe, pisoConsultorio } = useSelector(
    (state) => state.hce,
  );
  const [open, setOpen] = useState(props.open);
  const { efectorMedico } = props;
  const dispatch = useDispatch();
  const [idEfectorRed, setIdEfectorRed] = useState(efectorMedico[0]?.idEfectorRed);
  const [idCentroMedico, setIdCentroMedico] = useState('');
  const [openListaTurnos, setOpenListaTurnos] = useState(false);
  const [consultorio, setConsultorio] = useState('');
  const [piso, setPiso] = useState('');


  const onSubmitHandler = () => {
    setOpenListaTurnos(true);
    setOpen(false);
  };

  const onClose = () => {
    setOpen(false);
    dispatch(setActiveBreadcrumbHce(MENU_HCE.DESELECCIONAR));
  };

  useEffect(() => {
    if (idEfectorRed > 0) {
      dispatch(traerRelacionEfectorCMEspecialidad(idEfectorRed));
    }
  }, [idEfectorRed]);

  useEffect(() => {
    if (idCentroMedico > 0) {
      dispatch(traerPisoConsultorio(idEfectorRed, idCentroMedico, fecha));
    }
  }, [idCentroMedico]);

  useEffect(() => {
    // Esta función se ejecutará cuando pisoConsultorio cambie
    if (Array.isArray(pisoConsultorio) && pisoConsultorio.length > 0) {
      setPiso(pisoConsultorio[0]?.piso);
      setConsultorio(pisoConsultorio[0]?.consultorio);
    }
  }, [pisoConsultorio]);

  useEffect(() => {
    // Esta función se ejecutará cuando pisoConsultorio cambie
    if (Array.isArray(relEfectorCMEspe) && relEfectorCMEspe.length > 0) {
      setIdCentroMedico(relEfectorCMEspe[0]?.id_centroMedico);

    }
  }, [relEfectorCMEspe]);

  return (
    <React.Fragment>
      {openListaTurnos && (
        <ListadoPacientes
          open={openListaTurnos}
          close={() => {
            setOpenListaTurnos(false);
          }}
          idEfectorRed={idEfectorRed}
          idCentroMedico={idCentroMedico}
          piso={piso}
          consultorio={consultorio}
          relEfectorCMEspe={relEfectorCMEspe}
        />
      )}
      <Dialog fullWidth maxWidth="md" open={open} onClose={onClose}>
        <DialogTitle>Seleccione</DialogTitle>
        <DialogContent>
          <ValidatorForm onSubmit={onSubmitHandler}>
            <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                style={{ alignSelf: 'center', paddingLeft: 16 }}
              >
                {Array.isArray(efectorMedico) && efectorMedico.length > 0 && (
                  <SelectValidator
                    fullWidth
                    label="Seleccionar Profesional"
                    name="idEfectorRed"
                    value={idEfectorRed}
                    onChange={(e) => setIdEfectorRed(e.target.value)}
                    validators={['required']}
                    errorMessages={['Este campo es requerido']}
                  >
                    {efectorMedico.map((item) => (
                      <MenuItem
                        key={item.idEfectorRed}
                        value={item.idEfectorRed}
                      >
                        {`${item.nombreEfector}`}
                      </MenuItem>
                    ))}
                  </SelectValidator>
                )}
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                style={{ alignSelf: 'center', paddingLeft: 16 }}
              >
                {Array.isArray(relEfectorCMEspe) &&
                  relEfectorCMEspe.length > 0 && (
                    <SelectValidator
                      fullWidth
                      label="Seleccionar Centro Médico"
                      name="idCentroMedico"
                      value={idCentroMedico}
                      onChange={(e) => setIdCentroMedico(e.target.value)}
                      validators={['required']}
                      errorMessages={['Este campo es requerido']}
                    >
                      {relEfectorCMEspe.map((item) => (
                        <MenuItem
                          key={item.id_centroMedico}
                          value={item.id_centroMedico}
                        >
                          {`${item.descripcion_Centro}`}
                        </MenuItem>
                      ))}
                    </SelectValidator>
                  )}
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                lg={6}
                style={{ alignSelf: 'center', paddingLeft: 16 }}
              >
                {Array.isArray(relEfectorCMEspe) &&
                  relEfectorCMEspe.length > 0 && (
                    <TextValidator
                      fullWidth
                      variant="outlined"
                      multiline
                      label="Piso"
                      name="piso"
                      value={piso}
                      onChange={(e) => setPiso(e.target.value)}
                      disabled={false}
                      validators={['required']}
                      errorMessages={['Este campo es requerido']}
                    />
                  )}
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                lg={6}
                style={{ alignSelf: 'center', paddingLeft: 16 }}
              >
                {Array.isArray(relEfectorCMEspe) &&
                  relEfectorCMEspe.length > 0 && (
                    <TextValidator
                      fullWidth
                      variant="outlined"
                      multiline
                      label="Consultorio"
                      name="consultorio"
                      value={consultorio}
                      onChange={(e) => setConsultorio(e.target.value)}
                      disabled={false}
                      validators={['required']}
                      errorMessages={['Este campo es requerido']}
                    />
                  )}
              </Grid>
            </Grid>
            <div
              style={{
                margin: '1rem 0',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-evenly',
              }}
            >
              <Button variant="contained" color="primary" onClick={onClose}>
                Cancelar
              </Button>
              <Button
                type="submit"
                variant="contained"
                disabled={props.disabled}
                color="primary"
              >
                Guardar
              </Button>
            </div>
          </ValidatorForm>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};
